var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTakeAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13 16C10.7909 16 9.00002 14.2091 9.00002 12C9.00002 9.79086 10.7909 8 13 8C15.2092 8 17 9.79086 17 12C17 14.2091 15.2092 16 13 16ZM20.5 10.5H22C22.8284 10.5 23.5 11.1716 23.5 12C23.5 12.8284 22.8284 13.5 22 13.5H20.5C19.6716 13.5 19 12.8284 19 12C19 11.1716 19.6716 10.5 20.5 10.5ZM17.0607 5.87132L18.1213 4.81066C18.7071 4.22487 19.6569 4.22487 20.2427 4.81066C20.8284 5.39645 20.8284 6.34619 20.2427 6.93198L19.182 7.99264C18.5962 8.57843 17.6465 8.57843 17.0607 7.99264C16.4749 7.40685 16.4749 6.45711 17.0607 5.87132ZM13 1.5C13.8284 1.5 14.5 2.17157 14.5 3V4.5C14.5 5.32843 13.8284 6 13 6C12.1716 6 11.5 5.32843 11.5 4.5V3C11.5 2.17157 12.1716 1.5 13 1.5ZM5.81068 4.81066C6.39646 4.22487 7.34621 4.22487 7.932 4.81066L8.99266 5.87132C9.57844 6.45711 9.57844 7.40685 8.99266 7.99264C8.40687 8.57843 7.45712 8.57843 6.87134 7.99264L5.81068 6.93198C5.22489 6.34619 5.22489 5.39645 5.81068 4.81066Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.74715 20.0426C3.0941 18.974 2 17.1148 2 15C2 11.6863 4.68629 9 8 9C10.7958 9 13.1449 10.9122 13.811 13.5H16.25C18.3211 13.5 20 15.1789 20 17.25C20 19.3211 18.3211 21 16.25 21H7.25C6.28818 21 5.41093 20.6379 4.74715 20.0426Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeAction);
export default __webpack_public_path__ + "static/media/TakeAction.b7de40eb81a88b2dd1763f2259a47c4e.svg";
export { ForwardRef as ReactComponent };